import { SET_NOT_SURE_ANSWERED_QUESTIONS } from './intake.actionTypes';
import { NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY } from './intake.constants';

export const setNotSureAnsweredQuestions = (data) => (dispatch) => {
  localStorage.setItem(NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY, JSON.stringify(data));
  dispatch({ type: SET_NOT_SURE_ANSWERED_QUESTIONS, payload: data });
};
